var app = angular.module("leonardo");

var UnitList = function($scope, $q, $controller, $rootScope, $state, $filter, ngDialog, UnitService, PermissionService,
                        FilterService, AuthDataService) {
  $scope.units = [];
  $scope.unitDelete = $state.current.unitDelete;
  $scope.authDataService = AuthDataService;

  $scope.permissionService = PermissionService;

  $scope.showUnitDeleteDialog = function(unit){
    ngDialog.openConfirm({
      template: 'views/templates/dialog/unit/delete-unit.html',
      controller: 'DeleteDialog',
      data: {
        object: unit,
        type: 'unit'
      }
    }).then(function(data){
      if (AuthDataService.isNotStaff()) {
        UnitService.updateCollection(data, true);
      }
      $scope.loadPage($scope.page);
    });
  };

  $scope.showUnitUnDeleteDialog = function(unit){
    ngDialog.openConfirm({
      template: 'views/templates/dialog/unit/undelete.html',
      controller: 'UnDeleteUnitDialog',
      data: {
        unit: unit
      }
    }).then(function(data){
      if (AuthDataService.isNotStaff()) {
        UnitService.updateCollection(data);
      }
      $scope.loadPage($scope.page);
    });
  };

  $scope.showUnitEditDialog = function(unit){
    UnitService.get(unit.id).then(function (data) {
      ngDialog.open({
        template: 'views/templates/dialog/unit/unit-form.html',
        className: 'ngdialog-theme-default ngdialog-template-edit',
        controller: 'UnitForm',
        data: {
          mode: 'edit',
          unit: data
        }
      });
    });
  };

  $scope.getEntitiesPromise = function(options, noCancel) {
    options.summary = true;
    var defer = $q.defer();
    if (!isNull($scope.unitDelete) && !$scope.unitDelete) {
      options.only_deleted = true;
    }
    if (FilterService.getFilter('account_reports')) {
      options.account = FilterService.getFilter('account_reports');
    }
    if (FilterService.getFilter('group_reports')) {
      options.group = FilterService.getFilter('group_reports');
    }
    if (FilterService.getFilter('portfolio_reports')) {
      options.portfolio = FilterService.getFilter('portfolio_reports');
    }
    if (FilterService.getFilter('property_reports')) {
      options.property = FilterService.getFilter('property_reports');
    }
    if (FilterService.getFilter('unit_number_search')) {
      options.number__icontains = FilterService.getFilter('unit_number_search');
    }
    if (FilterService.getFilter('unit_building_search')) {
      options.building__icontains = FilterService.getFilter('unit_building_search');
    }
    if (FilterService.getFilter('unit_type')) {
      options.unit_type = FilterService.getFilter('unit_type');
    }
    UnitService.getlist(options, noCancel).then(function (list) {
      $scope.units = list.results ? list.results : list;
      if ($scope.units.length === 0) {
        ngDialog.open({ template: 'views/templates/dialog/no-results.html'});
      }
      defer.resolve(list);
    }, function (error) {
      defer.reject(error);
    });
    return defer.promise;
  };

  $controller('TableFilterController', { $scope: $scope });

  $scope.$on('unit:updated', function(event, noCancel){
    $scope.loadPage($scope.page, noCancel);
  });

  $scope.$on('unit:created', function(event, noCancel){
    $scope.loadPage($scope.page, noCancel);
  });

  if (isNull($scope.unitDelete)){
    $scope.loadPage(1);
  }

};

app.controller('UnitList', ['$scope', '$q', '$controller', '$rootScope', '$state', '$filter', 'ngDialog', 'UnitService',
  'PermissionService', 'FilterService', 'AuthDataService', UnitList]);